import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as BillPayerActions from 'web-app/react/entities/bill-payers/actions';
import * as InstitutionActions from 'web-app/react/entities/institutions/actions';

import * as Actions from './actions';
import * as Api from './api';

const fetchAll = action$ =>
    action$.ofType(Actions.fetchAll.type).mergeMap(() =>
        Api.fetchBillPayerData()
            .flatMap(response => [
                BillPayerActions.fetchAllSuccess.action({billPayers: response.billPayers}),
                InstitutionActions.fetchAllSuccess.action(response.institutions),
                Actions.fetchAllSuccess.action(response.billPayers.map(bp => bp.billPayerId)),
            ])
            .catch(e => Observable.of(Actions.fetchAllFailed.action(e))),
    );

export default combineEpics(fetchAll);
